import { renderToStaticMarkup } from 'react-dom/server';

interface HeaderDonorTabsProps {
    userId: string | number;
    userType?: string;
    hasTeacherStats?: boolean;
}

interface TabItemProps {
    className: string;
    href: string;
    iconName: string;
    label: string;
}

const TabItem = ({ className, href, iconName, label }: TabItemProps) => (
    <li className={className}>
        <a target="_top" className={`js-${className}`} href={href}>
            <svg className={`icon icon-${iconName} standalone`}>
                <use xlinkHref={`/images/icon/icon-junior.svg#icon-${iconName}`}></use>
            </svg>
            {label}
        </a>
    </li>
);

const HeaderDonorTabs = ({ userType, hasTeacherStats }: HeaderDonorTabsProps) => {
    const isTeacher = userType === 'teacher';

    return (
        <ul className="DCtabs donor-tabs js-donor-tabs">
            {isTeacher
                ? (
                    <>
                        <TabItem
                            className="projects"
                            href={`${secureBaseURL}teacher/teacher.html?projects=true`}
                            iconName="rocket"
                            label="Projects"
                        />
                        <TabItem
                            className="teacher-profile"
                            href={`${secureBaseURL}common/public-info.html`}
                            iconName="bank"
                            label="Teaching details"
                        />
                        <TabItem
                            className="private-info"
                            href={`${secureBaseURL}common/private-info.html`}
                            iconName="lock"
                            label="Private info"
                        />
                        {hasTeacherStats && (
                            <TabItem
                                className="teacher-stats"
                                href={`${secureBaseURL}profile/teacher-stats.html`}
                                iconName="star"
                                label="Teacher stats"
                            />
                        )}
                    </>
                )
                : (
                    <>
                        <TabItem
                            className="donor-profile"
                            href={`${secureBaseURL}common/public-info.html`}
                            iconName="masculineuser"
                            label="Public info"
                        />
                        <TabItem
                            className="private-info"
                            href={`${secureBaseURL}common/private-info.html`}
                            iconName="lock"
                            label="Private info"
                        />
                    </>
                )}
            <TabItem
                className="donor-campaigns"
                href={`${secureBaseURL}common/donation-info.html?tab=GIVING_PAGES`}
                iconName="flag"
                label="Campaigns"
            />
            <TabItem
                className="giving-history"
                href={`${secureBaseURL}common/donation-info.html?tab=PROJECTS_SUPPORTED`}
                iconName="counterclockwise"
                label="Giving history"
            />
            <TabItem
                className="favorites"
                href={`${secureBaseURL}donors/favorites.html`}
                iconName="bookmark"
                label="Following"
            />
            <TabItem
                className="recurring-donations"
                href={`${secureBaseURL}donors/monthly-giving.html`}
                iconName="calendar"
                label="Monthly Giving"
            />
            <TabItem
                className="email-preferences"
                href={`${secureBaseURL}common/email_preferences.html`}
                iconName="mail"
                label="Email preferences"
            />
            <TabItem
                className="sign-out"
                href={`${secureBaseURL}common/signout.html`}
                iconName="delete"
                label="Sign out"
            />
        </ul>
    );
};

export const renderHeaderDonorTabs = (props: HeaderDonorTabsProps): string => {
    return renderToStaticMarkup(<HeaderDonorTabs {...props} />);
};
